import React from 'react';
import useGetDocumentsMetaData from '@data/documentSignedUrl/hooks/useGetDocumentsMetaData';
import { DocumentsMetaDataResponse } from '@data/documentSignedUrl/types/DocumentsMetaDataResponse';
import { useSelector } from 'react-redux';
import { RootState } from '@interfaces/rootState';
import { CaseDetailsState } from '@interfaces/CaseDetails/CaseDetailsState';
import { CaseDetailsSelector } from '@store/selectors/CaseDetailsSelector';
import { Attachment } from '@interfaces/SurgeryRequest/Attachment';

const createDocumentIdList = (attachments: Attachment[] | undefined) => {
	const documentIds: string[] = [];
	if (attachments?.length) {
		attachments.forEach((attachment) => {
			documentIds.push(attachment.id)
		});
	}
	return documentIds;
};

export interface UseCaseDetailsDocsMetaDataReturn {
	documentsMetaData: DocumentsMetaDataResponse | undefined;
}

export const useCaseDetailsDocsMetaData = (): UseCaseDetailsDocsMetaDataReturn => {
	const { details } = useSelector<RootState, CaseDetailsState>(CaseDetailsSelector);
	const attachments = details?.attachments;
	const documentIdList = React.useMemo(() => createDocumentIdList(attachments), [attachments]);
	const [documentsMetaData, setDocumentsMetaData] = React.useState<DocumentsMetaDataResponse | undefined>();
	const getDocumentsMetaData = useGetDocumentsMetaData();

	React.useEffect(() => {
		if (!documentIdList?.length) { return; }

		getDocumentsMetaData({
			data: {
				ids: documentIdList,
			},
			onSuccess: (response) => setDocumentsMetaData(response.data)
		});
	}, [getDocumentsMetaData, documentIdList]);

	return { documentsMetaData };
};
